var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100% !important","height":"220px"},attrs:{"id":"paiementIframe","src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }